<template>
  <div class="c-gallery">
    <div ref="gallery">
      <div class="c-page-banner c-page-banner--no-size" v-for="image in images" :key="image.id">
        <img :src="image.url" alt="">
        <div class="c-page-banner__credit u-st2" v-if="image.credit">&copy; {{ image.credit }}</div>
      </div>
    </div>
    <button ref="prev" class="c-gallery__btn c-gallery__btn--prev" @click="prevImage" v-if="images.length > 1">
      <img src="@/assets/caret-left-blue.svg" height="32" alt="Left caret">
    </button>
    <button ref="next" class="c-gallery__btn c-gallery__btn--next" @click="nextImage" v-if="images.length > 1">
      <img src="@/assets/caret-right-blue.svg" height="32" alt="Right caret">
    </button>
  </div>
</template>

<script>
import Siema from 'siema'

export default {
  name: 'Gallery',
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  mounted () {
    this.initGallery()
  },
  methods: {
    initGallery () {
      let selector = this.$refs.gallery

      this.mySiema = new Siema({
        selector: selector,
        loop: true,
        draggable: false,
        duration: 800
      })
    },
    prevImage () {
      this.mySiema.resizeHandler()
      this.mySiema.prev()
    },
    nextImage () {
      this.mySiema.resizeHandler()
      this.mySiema.next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gallery.vue